// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../shared/images/Chat/Close_chatPanel_button.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.license-info-container {
    display: flex;
    flex-direction: column;
}

.license-expires-dialog-container {
    margin-left: 5px;
    margin-right: 5px;
    width: 99%;
    align-self: center;
    display: flex;
    justify-content: center;
    background-color: #f4dd48;
    align-items: center;
    margin-top: 14px;
    border-radius: 2px;
    border: 2px #666666 solid;
    height: 30px;
    opacity: 0.7;
    cursor: pointer;
}

.close-dialog-button {
    position: absolute;
    height: 26px;
    right: 12px;
}


.close-dialog-button img {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    width: 2.6rem;
    border-radius: 50%;
    padding: 6px;
    margin-left: -0rem;
    cursor: pointer;
}

.close-dialog-button img:hover {
    padding: 6px;
    border-radius: 50%;
    box-shadow: 0px 0px 2px 0px #000;
}



.license-expires-dialog-container__text {
    margin-left: 10px;
    margin-bottom: 3px;
    margin-right: 20px;
    font-size: 18px;
}

`, "",{"version":3,"sources":["webpack://./src/app/chat/license-expires-dialog/LicenseExpiresDialog.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;IACV,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;;AAGA;IACI,gDAAmE;IACnE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;AACpC;;;;AAIA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;AACnB","sourcesContent":[".license-info-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.license-expires-dialog-container {\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    width: 99%;\r\n    align-self: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    background-color: #f4dd48;\r\n    align-items: center;\r\n    margin-top: 14px;\r\n    border-radius: 2px;\r\n    border: 2px #666666 solid;\r\n    height: 30px;\r\n    opacity: 0.7;\r\n    cursor: pointer;\r\n}\r\n\r\n.close-dialog-button {\r\n    position: absolute;\r\n    height: 26px;\r\n    right: 12px;\r\n}\r\n\r\n\r\n.close-dialog-button img {\r\n    content: url(\"../../shared/images/Chat/Close_chatPanel_button.svg\");\r\n    width: 2.6rem;\r\n    border-radius: 50%;\r\n    padding: 6px;\r\n    margin-left: -0rem;\r\n    cursor: pointer;\r\n}\r\n\r\n.close-dialog-button img:hover {\r\n    padding: 6px;\r\n    border-radius: 50%;\r\n    box-shadow: 0px 0px 2px 0px #000;\r\n}\r\n\r\n\r\n\r\n.license-expires-dialog-container__text {\r\n    margin-left: 10px;\r\n    margin-bottom: 3px;\r\n    margin-right: 20px;\r\n    font-size: 18px;\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
